module.exports = __webpack_public_path__ + "assets/img/exam_cbt_foot.6af0ba2e.jpg";